<template>
  <div class="tags-box">
    <el-dialog :title="'图集详情'" :visible.sync="dialogVisible" :width="width" height=100% :before-close="handleClose" :close-on-click-modal="false">
      <div class="picturePopup" :style="{  overflow: over}">
        <div v-for="(item,i) in pictureList" :key="i" class="pictureInside">
          <base-upload :cover="item.src" :action="action" @successCallback="item.successCallback" :wSize="360" :hSize="480" :width="'200px'" :height="'260px'" :hide="true"></base-upload>
          <el-button type="danger" icon="el-icon-delete" circle size="small" class="deleteButton" @click="deletePicture(i)"></el-button>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="addPicture">新增</el-button>
        <el-button type="primary" size="small" @click="submitDate()" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from '@/utils/serverUrlConfig'
import API from '@/api'
export default {
  data() {
    return {
      id: '',
      flag: false,
      dialogVisible: false,
      // 封面上传地址
      action: baseConfig.baseServerUrl + '/vid/uploadStatic',
      imgUrl: baseConfig.imgUrl,
      pictureList: [],
      picturePopupLength: ['260px','470px','680px'],
    }
  },
  computed: {
    width() {
      if(this.pictureList.length <4 && this.pictureList.length > 0) {
        return this.picturePopupLength[this.pictureList.length-1]
      } else if(this.pictureList.length < 7){
        return '680px'
      } else {
        return '700px'
      }
    },
    over() {
      return this.pictureList.length < 6 ? 'hidden' : 'auto'
    }
  },
  methods: {
    // 封面图上传成功回调
    successCallback(res) {
      this.params.cover = res.data.coverImg
    },
    // 删除某张图片
    deletePicture(i) {
      if(this.pictureList.length === 1) {
        this.$message.error('请至少保留一张！')
        return
      }
      this.pictureList.splice(i,1)
    },
    // 新增图片
    addPicture() {
      let obj = {
        src: '',
        successCallback(res) {
           obj.src = res.data.coverImg
        }
      }
      this.pictureList.push(obj)
    },
    // 提交表单
    submitDate() {
      let arr = [];
      this.pictureList.forEach(item => {
        arr.push(item.src)
      })
      this.updateErrFeedback({cover:arr, id: this.id})
    },
    // 提交图集
    updateErrFeedback(params) {
      API.updateErrFeedback(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功！',
            type: 'success'
          });
          this.$emit("handlerChannelList")
        } else {
          this.$message.error('操作失败！');
        }
        this.handleClose()
        this.flag = false
      }).catch(() => {
        this.handleClose()
        this.flag = false
      })
    },
    // 打开弹窗并初始化tags数据
    open(pictureArr, id) {
      this.dialogVisible = true
      this.id = id
      let arr = [];
      for(var i = 0; i< pictureArr.length; i++) {
        let obj = {
          src: pictureArr[i],
          successCallback(res) {
            obj.src = res.data.coverImg
          }
        }
          arr.push(obj)
      }
      this.pictureList = arr
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.pictureList = []
    },
  }
}
</script>
<style scoped lang="scss">
.tags-box {
  .el-dialog {
    padding: 0 !important;
    margin: 0 !important;
  }
  .input-box {
    margin-top: 15px;
    text-align: left;
  }
  .el-input {
    width: 200px;
    margin-right: 10px;
  }
  .picturePopup {
    border: solid 5px black;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    max-height: 580px;
    .pictureInside {
      margin: 5px;
      position: relative;
      .deleteButton {
        position: absolute;
        opacity: 0.5;
        top: 0;
        right: 0;
      }
    }
  }
}
</style>
